<template>
  <div class="panel-list-page">
    <div class="pl-card">
      <div class="pl-card__header">
        <div class="pl-card__title-wrap">
          <span class="pl-card__icon" aria-hidden="true">
            <CIcon name="iconList"/>
          </span>
          <div>
            <h1 class="pl-card__title">لیست مقادیر خصوصیات</h1>
            <p class="pl-card__sub">مدیریت مقادیر هر خصوصیت محصول</p>
          </div>
        </div>
        <div class="pl-toolbar">
          <button type="button" class="pl-btn pl-btn--primary" @click="openCreateModal()">
            <CIcon name="iconPlus"/>
            <span>افزودن مقدار</span>
          </button>
        </div>
      </div>

      <div class="pl-card__body">
        <CDataTableFixed
          class="pl-table"
          :items="items"
          :fields="fields"
          :items-per-page="20"
          hover
          sorter
          pagination
          :noItemsView="{ noItems: 'مقداری یافت نشد' }"
        >
          <template #no-items-view>
            <div class="pl-empty">
              <span class="pl-empty__icon" aria-hidden="true">
                <CIcon name="iconList"/>
              </span>
              <p class="pl-empty__title">مقداری یافت نشد</p>
              <p class="pl-empty__sub">برای شروع، یک مقدار جدید اضافه کنید.</p>
              <button type="button" class="pl-btn pl-btn--primary" @click="openCreateModal()">
                <CIcon name="iconPlus"/>
                <span>افزودن مقدار</span>
              </button>
            </div>
          </template>

          <template #row="{ item }">
            <td>
              <span class="pl-muted">{{ item.row_id + 1 }}</span>
            </td>
          </template>

          <template #image="{ item }">
            <td>
              <div class="pl-thumb" v-if="item.image">
                <CImg width="44px" height="44px" :src="item.image"/>
              </div>
              <span
                v-else-if="item.view_type == 1 && item.color"
                class="pl-color-swatch"
              >
                <span class="pl-color-swatch__dot" :style="{ backgroundColor: item.color }"/>
              </span>
              <span v-else class="pl-muted">—</span>
            </td>
          </template>

          <template #نام="{ item }">
            <td>
              <span class="pl-name">{{ item.title.title }}</span>
            </td>
          </template>

          <template #عملیات="{ item }">
            <td class="pl-ops-cell">
              <div class="pl-ops">
                <button type="button" class="pl-icon-btn pl-icon-btn--warn" title="ویرایش" @click="openEditModal(item)">
                  <CIcon name="iconEdit"/>
                </button>
                <button type="button" class="pl-icon-btn pl-icon-btn--danger" title="حذف" @click="delete_dialog(item)">
                  <CIcon name="iconTrash"/>
                </button>
              </div>
            </td>
          </template>
        </CDataTableFixed>
      </div>
    </div>

    <CModal
      :show.sync="form_modal"
      :centered="true"
      size="lg"
      :title="status_form == 0 ? 'ثبت ایتم خصوصیت' : 'ویرایش ایتم خصوصیت'"
      @update:show="onFormModalToggle"
    >
      <div class="pl-form">
        <CRow>
          <CCol col="12" md="6">
            <CInput
              v-model="name"
              class="required"
              label="نام ایتم"
            />
          </CCol>
          <CCol col="12" md="6">
            <CInput
              v-model="code"
              class="required"
              label="کد ایتم"
            />
          </CCol>
          <CCol col="12" md="6">
            <CSelect
              :options="view_types"
              :value.sync="view_type"
              label="نوع ایکون"
            />
          </CCol>
          <CCol col="12" md="6" v-if="view_type == 1">
            <CInput
              type="color"
              label="رنگ"
              v-model="color"
            />
          </CCol>
          <CCol col="12" v-if="view_type == 2">
            <ImageSelector
              label="تصویر"
              :media_id.sync="file"
              default_archive="product_bundle"
              :preview-image="previewImage"
            />
          </CCol>
        </CRow>
      </div>
      <template #footer>
        <button type="button" class="pl-btn pl-btn--ghost" @click="closeFormModal()">انصراف</button>
        <button type="button" class="pl-btn pl-btn--primary" @click="login()">
          <CIcon name="iconCheck"/>
          <span>{{ status_form == 0 ? 'ثبت آیتم' : 'ویرایش آیتم' }}</span>
        </button>
      </template>
    </CModal>

    <CModal
      class="pl-modal pl-modal--danger"
      :show.sync="delete_modal"
      :no-close-on-backdrop="true"
      :centered="true"
      size="md"
    >
      <template #header>
        <div class="pl-modal__head">
          <span class="pl-modal__icon pl-modal__icon--danger" aria-hidden="true">
            <CIcon name="iconTrash"/>
          </span>
          <div>
            <h6 class="pl-modal__title">حذف مقدار</h6>
            <p class="pl-modal__sub">این عمل قابل بازگشت نیست</p>
          </div>
        </div>
        <button type="button" class="pl-modal__close" title="بستن" @click="delete_modal = false">×</button>
      </template>
      <div class="pl-modal__body">
        <p class="pl-modal__text">آیا مایل به حذف این مقدار هستید؟</p>
        <label class="pl-modal__label">مقدار حذف‌شده در قیمت‌ها به مقدار زیر منتقل شود</label>
        <CSelect
          :options="[{label:'انتخاب کنید',value:0},...items.filter(x=>x.value!=status_form)]"
          :value.sync="selected_delete_item"
        />
      </div>
      <template #footer>
        <button type="button" class="pl-btn pl-btn--ghost" @click="delete_modal = false">انصراف</button>
        <button type="button" class="pl-btn pl-btn--danger" @click="delete_item()">
          <CIcon name="iconTrash"/>
          <span>تأیید حذف</span>
        </button>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "@/api/http";
import {bus} from "../../../main";

export default {
  name: 'Login',
  data() {
    return {
      form_modal: false,
      confirm_delete_name: new Date().getTime() + "_" + this.$vnode.tag,
      name: '',
      file: [],
      color: '',
      code: '',
      view_type: 0,
      view_types: [{label: 'بدون نمایش', value: 0}, {label: 'نمایش رنگ', value: 1}, {label: 'نمایش تصویر', value: 2}],
      previewImage: null,
      description: '',
      delete_modal: false,
      selected_delete_item: 0,
      items: [],
      fields: [
        {key: 'row', label: '#', _style: 'width:10%'},
        {key: 'image', label: 'تصویر', _style: 'width:10%'},
        {key: 'نام', _style: 'width:10%'},
        {key: 'عملیات', _style: 'width:40%;'},
      ],
      details: [],
      collapseDuration: 0,
      status_form: 0
    }
  },
  mounted() {
    bus.$on(this.confirm_delete_name, (data) => {
      if (data == 'true') {
        this.delete_item();
      } else {
        this.status_form = 0;
      }
    });
    this.get_categories();
  },
  watch: {},
  methods: {
    openCreateModal() {
      this.cancel_form();
      this.form_modal = true;
    },
    openEditModal(item) {
      this.editDetails(item);
      this.form_modal = true;
    },
    closeFormModal() {
      this.form_modal = false;
      this.cancel_form();
    },
    onFormModalToggle(show) {
      if (!show) {
        this.cancel_form();
      }
    },
    cancel_form() {
      this.name = '';
      this.code = '';
      this.view_type = 0;
      this.color = '';
      this.file = [];
      this.previewImage = null;
      this.status_form = 0;
    },
    editDetails(item) {
      this.name = item.title.title;
      this.code = item.code;
      this.view_type = parseInt(item.view_type);
      this.color = item.color;
      this.file = item.image_id;
      this.status_form = item.id;
    },
    get_categories() {
      var self = this;
      var formData = new FormData();
      formData.append("id", this.$route.params.bundle_id)
      axios.post('/api/admin/product/get_bundle_items', formData, {}).then(function (response) {
        var content_cats = response.data;
        content_cats.tags.forEach(function (val) {
          val.label = val.title.title;
          val.value = val.id;
        })
        self.items = content_cats.tags.map((item, row_id) => {
          return {...item, row_id}
        });
      })
        .catch(function (error) {
          console.log(error);
        });
    },
    goRegister() {
      this.$router.push({path: 'register'});
    },
    login() {
      let self = this;
      const formData = new FormData()
      let url;
      if (this.status_form == 0) {
        url = "/api/admin/product/add_bundle_item";
      } else {
        url = "/api/admin/product/update_bundle_item";
        formData.append('id', this.status_form)
      }

      formData.append('image', this.file[0]);
      formData.append('name', this.name);
      formData.append('code', this.code);
      formData.append('view_type', this.view_type);
      formData.append('color', this.color);
      formData.append('bundle_id', this.$route.params.bundle_id);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);
        self.form_modal = false;
        self.status_form = 0;
        self.name = '';
        self.code = '';
        self.get_categories();
      })
        .catch(function (error) {
          console.log(error);
        });
    },
    delete_dialog(item) {
      this.delete_modal = true
      this.status_form = item.id;
    },
    delete_item() {
      if (this.selected_delete_item == 0) {
        this.$root.modal_component.show_danger_toast("لطفا یک مقدار جایگزین انتخاب کنید");
        return false
      }

      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/product/delete_bundle_item";

      formData.append('id', this.status_form);
      formData.append('selected_delete_item', this.selected_delete_item);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);
        self.status_form = 0;
        self.delete_modal = false;
        self.selected_delete_item = 0;
        self.get_categories();
      })
        .catch(function (error) {
          console.log(error);
        });
    },
  }
}
</script>
